<template>
  <div>
    <slot name="activate" :open-dialog="openDialog" />

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="font-16 font-black">
          <v-form ref="formRef">
            <div class="d-flex align-center gap-12 mb-4">
              <i class="rd-store font-32 font-red"></i>
              <div>
                <section class="font-20 font-w-500">
                  {{ data.customer_name || '-' }}
                </section>
                <section class="font-16 font-grey">
                  {{ data.ScgBPNumber || '-' }}
                </section>
              </div>
            </div>
            <div class="mb-4">
              <span class="font-grey">รายละเอียดงาน : </span>
              <span>{{ data.detail || '-' }}</span>
            </div>
            <div
              class="d-flex flex-wrap mb-4"
              style="border-radius: 8px; background: #f9f9f9"
            >
              <div class="flex-grow-1 flex-shrink-0 pa-4">
                <section class="font-14 font-grey">จังหวัด/อำเภอ</section>
                <section>
                  {{ data.PROVINCE_NAME || '-' }}/{{ data.AMPHUR_NAME || '-' }}
                </section>
              </div>
              <div class="flex-grow-1 flex-shrink-0 pa-4">
                <section class="font-14 font-grey">ประเภทงาน</section>
                <section>{{ data.task_type_name || '-' }}</section>
              </div>
              <div class="flex-grow-1 flex-shrink-0 pa-4">
                <section class="font-14 font-grey">กำหนดเสร็จ</section>
                <section>{{ data.due_date || '-' }}</section>
              </div>
            </div>
            <div v-if="data.task_type === '3'" class="mb-4">
              <div class="d-flex align-center gap-12 mb-4">
                <div class="d-flex align-center gap-12">
                  <i class="rd-coins font-32 font-red"></i>
                  <section class="font-18 font-w-500">ประเภทเสนอราคา</section>
                </div>
                <div
                  v-if="mode === 'show' && data.winloss === '1'"
                  class="task-type--win"
                >
                  Win
                </div>
                <div
                  v-if="mode === 'show' && data.winloss === '2'"
                  class="task-type--loss"
                >
                  Loss
                </div>
                <div
                  v-if="mode === 'show' && data.winloss === '3'"
                  class="task-type--follow-up"
                >
                  ติดตามต่อ
                </div>
              </div>

              <div v-if="mode === 'show' && data.winloss === '3'">
                <span class="font-grey">วันที่: </span>
                <span>
                  {{ data.start_date }} -
                  {{ data.end_date }}
                </span>
              </div>

              <div v-if="mode === 'create'" class="d-flex flex-wrap gap-12">
                <section
                  class="bid-type"
                  :class="{ 'bid-type--active': bidStatus === '1' }"
                  @click.prevent="bidStatus = '1'"
                >
                  Win
                </section>
                <section
                  class="bid-type"
                  :class="{ 'bid-type--active': bidStatus === '2' }"
                  @click.prevent="bidStatus = '2'"
                >
                  Loss
                </section>
                <section
                  class="bid-type"
                  :class="{ 'bid-type--active': bidStatus === '3' }"
                  @click.prevent="bidStatus = '3'"
                >
                  ติดตามต่อ
                </section>
              </div>

              <div
                v-if="mode === 'create' && bidStatus === '2'"
                class="d-flex flex-wrap gap-12 align-center my-4"
              >
                <section class="flex-shrink-0" style="flex: 1">
                  <span class="font-14">โปรดระบุเหตุผลที่ Loss</span>
                  <span class="font-red">*</span>
                </section>
                <section class="flex-shrink-0" style="flex: 2">
                  <v-select
                    v-model="reasonGroupId"
                    :items="reasonGroupList"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v]"
                    color="#a9182a"
                    placeholder="หมายเหตุ"
                    append-icon="mdi-chevron-down"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </section>
              </div>
              <div v-if="mode === 'show' && data.winloss === '2'">
                <section>{{ data.reason_group_name || '-' }}</section>
              </div>
            </div>

            <v-row v-if="mode === 'create' && bidStatus === '3'">
              <v-col cols="12">
                <v-menu
                  v-model="followUpEndDateMenu"
                  :close-on-content-click="true"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="dateFormat(followUpEndDate)"
                      append-icon="rd-calendar-days"
                      color="#a9182a"
                      readonly
                      :rules="[(v) => !!v || 'ระบุกำหนดเสร็จครั้งต่อไป']"
                      v-bind="attrs"
                      v-on="on"
                      @click:append.prevent="followUpEndDateMenu = true"
                    >
                      <template #label>
                        <span>กำหนดเสร็จครั้งต่อไป</span>
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="followUpEndDate"
                    color="#aa0c1e"
                    no-title
                    :min="minFollowUpEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <div>
              <div class="d-flex align-center gap-12 mb-2">
                <i class="rd-file-note font-32 font-red"></i>
                <section class="font-18 font-w-500">หมายเหตุ</section>
              </div>
              <div class="pa-3" style="border-radius: 4px; background: #fafafa">
                <div
                  v-if="mode === 'create'"
                  class="d-flex align-center mb-3 gap-8"
                >
                  <section>
                    <input
                      class="d-none"
                      ref="fileRef"
                      type="file"
                      accept="image/*"
                      @change="fileChange"
                    />
                    <button
                      class="btn-box"
                      @click.prevent="$refs.fileRef.click()"
                    >
                      <i class="rd-picture font-22 font-red"></i>
                    </button>
                  </section>
                  <section>
                    <button
                      v-if="isRecording"
                      class="btn-box"
                      @click.prevent="voiceRecorderStop"
                    >
                      <v-icon size="20" color="#a9182a"
                        >mdi-stop-circle-outline</v-icon
                      >
                    </button>
                    <button
                      v-else
                      class="btn-box"
                      @click.prevent="voiceRecorderStart"
                    >
                      <v-icon size="20" color="#a9182a">mdi-microphone</v-icon>
                    </button>
                  </section>
                </div>

                <v-textarea
                  v-if="mode === 'create'"
                  v-model="note"
                  placeholder="ระบุหมายเหตุ"
                  :rules="noteRules"
                  solo
                  flat
                >
                </v-textarea>

                <textarea
                  v-if="mode === 'show'"
                  :value="data.reason_detail"
                  class="todo-textarea"
                  placeholder="ระบุหมายเหตุ"
                  readonly
                ></textarea>

                <v-row>
                  <v-col
                    v-for="(item, index) in imgPreview"
                    :key="index"
                    cols="3"
                    style="position: relative"
                  >
                    <DialogImgPreview :src="item.file_img">
                      <template #activate="{ openDialog }">
                        <img
                          class="img-upload"
                          :src="item.file_img"
                          alt=""
                          @click.prevent="openDialog()"
                        />
                      </template>
                    </DialogImgPreview>
                    <section
                      v-if="mode === 'create'"
                      class="img-upload-remove"
                      @click.prevent="removeImg(index)"
                    >
                      <i class="rd-trash font-red"></i>
                    </section>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div
            v-if="mode === 'create'"
            class="d-flex justify-center gap-16 pb-6 w-100"
          >
            <button
              class="btn-red-outline"
              style="width: 140px; height: 45px"
              @click="dialog = false"
            >
              ยกเลิก
            </button>
            <button
              class="btn-red"
              style="width: 140px; height: 45px"
              @click="visitTaskTodoListByOSR()"
            >
              ยืนยัน
            </button>
          </div>
          <div
            v-if="mode === 'show'"
            class="d-flex justify-center gap-16 pb-6 w-100"
          >
            <button
              class="btn-red-outline"
              style="width: 140px; height: 45px"
              @click="dialog = false"
            >
              ปิด
            </button>
            <button
              v-if="isShowCancelDone"
              class="btn-red"
              style="width: 140px; height: 45px"
              @click="cancelDone"
            >
              ยกเลิกการทำ
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import DialogImgPreview from '@/components/dialog/DialogImgPreview.vue'

dayjs.extend(customParseFormat)

export default {
  components: {
    DialogImgPreview,
  },
  props: {
    mode: {
      type: String,
      default: 'create', // create, show
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      files: [],
      isRecording: false,
      note: '',
      bidStatus: '1', // 1 = win, 2 = loss, 3 = ติดตามต่อ
      reasonGroupId: '',
      reasonGroupList: [],
      followUpEndDateMenu: false,
      followUpEndDate: null,
    }
  },
  computed: {
    isShowCancelDone() {
      const dateNow = dayjs()
      const dueDate = dayjs(this.data.due_date, 'DD/MM/YYYY')
      if (
        dateNow.isSameOrBefore(dueDate, 'day') &&
        this.data.status_txt === 'ทำแล้ว'
      ) {
        return true
      }
      return false
    },
    minFollowUpEndDate() {
      return dayjs(this.data.due_date, 'DD/MM/YYYY')
        .add(1, 'day')
        .format('YYYY-MM-DD')
    },
    noteRules() {
      // validate เมื่อ เสนอราคา : win หรือ loss หรือ ติดตามต่อ
      if (
        this.data.task_type === '3' &&
        ['1', '2', '3'].includes(this.bidStatus)
      ) {
        return [
          (v) => !!v || 'กรุณาระบุหมายเหตุ',
          (v) => v.length >= 5 || 'กรุณาระบุหมายเหตุ อย่างน้อย 5 ตัวอักษร',
        ]
      } else {
        return []
      }
    },
    imgPreview() {
      if (this.mode === 'create') {
        return this.files
      }
      return this.data.image
    },
    recognition() {
      const SpeechRecognize =
        window.SpeechRecognition || window.webkitSpeechRecognition
      const recognition = new SpeechRecognize()
      recognition.lang = 'th-TH'
      return recognition
    },
  },
  mounted() {
    this.voiceRecorder()
  },
  methods: {
    cancelDone() {
      // close dialog
      this.dialog = false
      // show confirm
      Swal.fire({
        icon: 'warning',
        title: 'ต้องการยกเลิกการทำแล้ว\nใช่หรือไม่',
        showConfirmButton: true,
        confirmButtonText: `ตกลง`,
        confirmButtonColor: '#A9182A',
        showCancelButton: true,
        cancelButtonText: `ยกเลิก`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.$axios.post(
              `${this.$baseAPIControl}/todolist/cancelTask`,
              { todolist_id: this.data.todolist_id },
              { headers: this.setheaders },
            )
            if (res.data.items === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'ยกเลิกสําเร็จ',
                showConfirmButton: false,
                timer: 1500,
              })
              this.$emit('cancelTask')
            }
          } catch (error) {
            console.error(error)
            Swal.fire({
              icon: 'error',
              title: 'ทำรายการไม่สําเร็จ',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#A9182A',
              showCancelButton: false,
            })
          }
        }
      })
    },
    dateFormat(date) {
      if (date) {
        return dayjs(date).format('DD/MM/YYYY')
      }
      return null
    },
    async getReasonGroup() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/getReasonGroup`,
          {},
          { headers: this.setheaders },
        )
        if (res.status === 200) {
          this.reasonGroupList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    async visitTaskTodoListByOSR() {
      try {
        // validate form if task_type = 3 => เสนอราคา
        // reason group required
        if (this.data.task_type === '3') {
          const validate = this.$refs.formRef.validate()
          if (!validate) throw new Error('form invalid')
        }

        const payload = {
          todolist_id: this.data.todolist_id,
          winloss: this.data.task_type === '3' ? this.bidStatus : '', // ถ้า task_type =  "3" => เสนอราคา ให้ส่ง win = 1 , loss = 2, ติดตามต่อ = 3
          reason_group: this.reasonGroupId, //ถ้า winnloss =  "2" => loss ให้ required field
          reason_detail: this.note,
          pic: this.files.map((item) => ({
            name: item.file_name,
            file: item.file_img,
          })),
          end_date: this.bidStatus === '3' ? this.followUpEndDate : '',
        }

        const res = await this.$axios.post(
          `${this.$baseAPIControl}/todolist/visitTaskTodolistByOSR`,
          payload,
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'ทำรายการสำเร็จ',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.dialog = false
            this.$emit('closeDialog')
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    voiceRecorder() {
      this.recognition.addEventListener('result', (e) => {
        this.note += e.results[0][0].transcript
      })
      this.recognition.addEventListener('end', (e) => {
        if (this.isRecording) {
          this.recognition.start()
        }
      })
    },
    voiceRecorderStart() {
      this.recognition.start()
      this.isRecording = true
    },
    voiceRecorderStop() {
      this.recognition.stop()
      this.isRecording = false
    },
    openDialog() {
      this.dialog = true

      if (this.mode === 'create' && this.data.task_type === '3') {
        this.getReasonGroup()
      }
    },
    fileChange() {
      // convert file to base64
      const file = this.$refs.fileRef.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (event) => {
          // upload to server
          this.files.push({
            file_img: event.target.result,
            file_name: file.name,
          })
        }
        reader.readAsDataURL(file)
      }
      // reset input
      this.$refs.fileRef.value = ''
    },
    removeImg(index) {
      this.files = this.files.filter((_, i) => i !== index)
    },
  },
}
</script>

<style lang="scss" scoped>
.bid-type {
  flex-grow: 1;
  flex-shrink: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #858585;
  border: 1px solid #dfdfdf;
  background: #fff;
  cursor: pointer;
  &--active {
    color: #a50200;
    border: 1px solid #a50200;
    background: #fef2f3;
  }
}

.btn-box {
  width: 32px;
  height: 32px;
  border: 1px solid #ececec;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.todo-textarea {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  border: 1px solid #ececec;
  background: #fff;
  padding: 12px;
}

.img-upload {
  object-fit: cover;
  width: 100%;
  height: 72px;
  border-radius: 8px;
}
.img-upload-remove {
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  background: #fff;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-type {
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 500;
  &--win {
    @extend .task-type;
    background: #edf8ec;
    color: #259b12;
  }
  &--loss {
    @extend .task-type;
    background: #feeced;
    color: #ff5252;
  }
  &--follow-up {
    @extend .task-type;
    background: #ecf0fe;
    color: #5272ff;
  }
}
</style>
